'use client'

import {Button} from '@viptech/react-components'
import {Eye} from 'lucide-react'
import {forwardRef, type ComponentProps} from 'react'
import {cn} from 'src/layouts/main-layout/app-sidebar/utils/utils'

type Props = ComponentProps<'div'> & {
  spotlightMeasureRef?: React.Ref<HTMLSpanElement>
}

export const PortalViewSwitcherTrigger = forwardRef<HTMLDivElement, Props>(function PortalViewSwitcherTrigger({className, spotlightMeasureRef, ...props}, ref) {
  return (
    <div ref={ref} className={cn('group/trigger relative inline-flex', className)} {...props}>
      <Button
        variant='outlined'
        color='transparent'
        hoverColor='transparent'
        padding='0px'
        width='36px'
        height='36px'
        aria-label='Alternar visualização do portal'>
        <span
          ref={spotlightMeasureRef}
          data-slot='portal-view-switcher-spotlight-anchor'
          className='inline-flex size-9 shrink-0 items-center justify-center'
          aria-hidden>
          <Eye className='size-5 text-[#475467]' strokeWidth={1.75} />
        </span>
      </Button>

      <div
        role='tooltip'
        className='pointer-events-none absolute top-[calc(100%+10px)] left-1/2 z-50 -translate-x-1/2 opacity-0 transition-opacity duration-150 group-hover/trigger:opacity-100'>
        <div className='relative rounded-lg bg-[#1C232D] px-4 py-3 shadow-[0_4px_16px_rgba(16,24,40,0.24)]'>
          <span aria-hidden className='absolute -top-1 left-1/2 size-2 -translate-x-1/2 rotate-45 bg-[#1C232D]' />
          <p className='relative z-[1] text-left text-xs leading-[18px] font-normal whitespace-nowrap text-white'>Alternar visualização</p>
          <p className='relative z-[1] text-left text-xs leading-[18px] font-normal whitespace-nowrap text-white'>Novo portal disponível</p>
        </div>
      </div>
    </div>
  )
})
